<template>
  <div class="product-listing-skeleton__root">
    <div
      v-for="index in count"
      :key="index"
      class="product-listing-skeleton__item"
    >
      <svg class="placeholder" viewBox="0 0 231 221.4" width="179" height="179" aria-hidden="true" focusable="false">
        <path d="M190.1,52.4c14.8,0,26.9,12,26.9,26.9v56.4c0,46-37.3,83.3-83.3,83.3H98.8c-46,0-83.3-37.3-83.3-83.3V79.2c0-14.8,12-26.9,26.9-26.9h8.1c0,37.1,30.1,67.2,67.2,67.2s67.2-30.1,67.2-67.2H190.1z" />
        <circle cx="117.6" cy="52.4" r="48.4" />
      </svg>
      <span class="title mb20 serif my10 center-xs start-md" />
      <p class="description">
        <span style="width: 60%;" />
        <span style="width: 75%;" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductListingSkeleton',
  props: {
    count: {
      type: Number,
      default: 5
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

$skeleton-bg: color(white-smoke);
$skeleton-radius: 6px;
$skeleton-title-height: 22px;
$skeleton-line-height: 18px;
$skeleton-placeholder-fill: color(gainsboro);

.product-listing-skeleton {
  &__root {
    display: flex;
    width: 100%;
    overflow: hidden;
  }

  &__item {
    .placeholder {
      fill: $skeleton-placeholder-fill;
    }

    .title {
      display: block;
      width: 50%;
      height: $skeleton-title-height;
      background: $skeleton-bg;
      border-radius: $skeleton-radius;
    }

    .description {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 12px;

      span {
        display: block;
        height: $skeleton-line-height;
        background: $skeleton-bg;
        border-radius: $skeleton-radius;
      }
    }
  }
}
</style>
